import { stringToColor } from '@routes/MyAccount/components/MemberShipWithdrawal/ConfirmChat/stringTo';

export const getUserAvatarInfo = (userName: string) => {
  const userInitial = userName[0]?.toLocaleUpperCase() ?? '';
  const userColor = stringToColor(userName);

  return {
    userName,
    userInitial,
    userColor
  };
};
